import React from 'react';
import PropTypes from 'prop-types';
import Text from '../Text/Text';
import {formatDate} from '../../utils/formatDate.js';
import {formatNights} from '../../utils/formatNights.js';
import {isPartialUpgrade} from '../../utils/isPartialUpgrade.js';

const PartialUpgradeCaption = ({nights, stayNights, startDate, endDate, showNights = true, className}) => {
  if (!isPartialUpgrade(nights, stayNights)) {
    return null;
  }

  const parts = [];
  if (showNights) {
    parts.push(formatNights(Number(nights)));
  }
  if (startDate && endDate) {
    parts.push(`${formatDate(startDate, 'dd MMM')} → ${formatDate(endDate, 'dd MMM')}`);
  }
  if (parts.length === 0) {
    return null;
  }

  return (
    <Text as="small" size="xs" color="muted" className={className}>{parts.join(' · ')}</Text>
  );
};

PartialUpgradeCaption.propTypes = {
  nights: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  stayNights: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  showNights: PropTypes.bool,
  className: PropTypes.string,
};

export default PartialUpgradeCaption;
